/**
 * Arabic for build 5 — shared registers saved row by row: bringing an old
 * register across, a colleague's change that stopped yours, the call policy's
 * "someone saved after you opened it", and the names of the registers' rows.
 * Proposed; pending native aviation review.
 */
const ar: Record<string, string> = {
  /* the notices every register screen shows */
  "This register is still kept the old way.": "ما زال هذا السجل محفوظًا بالطريقة القديمة.",
  "The {what} is saved as one document, so two people saving at once overwrite each other.":
    "يُحفظ {what} مستندًا واحدًا، فإذا حفظ شخصان معًا كتب أحدهما فوق الآخر.",
  "Bring its {n} rows across once, and everyone saves row by row.":
    "انقل صفوفه البالغة {n} مرة واحدة، ليحفظ الجميع صفًا صفًا.",
  "Bringing across…": "جارٍ النقل…",
  "Bring it across": "انقله",
  "Someone who can change this register must bring it across.": "يجب أن ينقله شخص يملك صلاحية تعديل هذا السجل.",
  "{who} deleted {what} after you opened it.": "حذف {who} {what} بعد أن فتحته.",
  "{who} changed {what} after you opened it.": "غيّر {who} {what} بعد أن فتحته.",
  "Someone else": "شخص آخر",
  "Saved {when}.": "حُفظ في {when}.",
  "Your change was not saved. Their version is shown now; make your change again if it is still needed.":
    "لم يُحفظ تعديلك. تظهر الآن نسختهم؛ أعد تعديلك إن كان ما زال لازمًا.",
  "Your change was not saved. Close this and open it again to see theirs.":
    "لم يُحفظ تعديلك. أغلق هذا وافتحه من جديد لترى نسختهم.",
  "The register could not be read: {why}": "تعذّرت قراءة السجل: {why}",
  "There is no platform session to save to.": "لا توجد جلسة على المنصة للحفظ فيها.",
  "Bring the register across first, then make your change.": "انقل السجل أولًا، ثم أجرِ تعديلك.",
  "Saved in this browser's sample.": "حُفظ في عيّنة هذا المتصفح.",
  "There is nothing to bring across.": "لا يوجد ما يُنقل.",
  "{n} rows brought across. Everyone now saves row by row.": "نُقل {n} صفًا. يحفظ الجميع الآن صفًا صفًا.",

  /* the registers, by name */
  "docking unit register": "سجل وحدات الالتحام",
  "equipment register": "سجل المعدات",
  "facility inspections register": "سجل فحوص المرافق",
  "contracts register": "سجل العقود",

  /* one row, named in "someone else changed …" */
  "the docking unit on stand {stand}": "وحدة الالتحام في الموقف {stand}",
  "equipment item {tag}": "المعدة {tag}",
  "an entry in the equipment history": "قيدًا في سجل تاريخ المعدات",
  "the contractor for {trade}": "مقاول {trade}",
  "inspection {id} of {facility}": "الفحص {id} للمرفق {facility}",
  "the work order for finding {item}": "أمر العمل للملاحظة {item}",
  "a past repair": "إصلاحًا سابقًا",
  "the contract with {provider}": "العقد مع {provider}",
  "a version of a contract": "نسخة من عقد",

  /* who can call whom */
  "Someone else saved this rule after you opened it. Your changes were not saved.":
    "حفظ شخص آخر هذه القاعدة بعد أن فتحتها. لم تُحفظ تعديلاتك.",
  "Show their version": "اعرض نسختهم",
  "Last saved by {who}, {when}.": "آخر حفظ: {who}، {when}.",
};

export default ar;
